export const USE_FOR_OPTIONS = [
  { value: 'personal', label: 'walletEmails.useForPersonal' },
  { value: 'work', label: 'walletEmails.useForWork' },
  { value: 'both', label: 'walletEmails.useForBoth' },
];
